import { render, staticRenderFns } from "./OlCheckbox.vue?vue&type=template&id=39960d95&scoped=true"
import script from "./OlCheckbox.vue?vue&type=script&lang=js"
export * from "./OlCheckbox.vue?vue&type=script&lang=js"
import style0 from "./OlCheckbox.vue?vue&type=style&index=0&id=39960d95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39960d95",
  null
  
)

export default component.exports